import styled, { css, DefaultTheme } from "styled-components";
import { BadgeVariant } from "./BadgeChip";

export const getVariantTextColor = (
  theme: DefaultTheme,
  variant: BadgeVariant,
) =>
  ({
    [BadgeVariant.PRIMARY]: theme.colors.grey_10,
    [BadgeVariant.SECONDARY]: theme.colors.purple_8,
  })[variant];

const variantStyles = (theme: DefaultTheme, variant: BadgeVariant) =>
  ({
    [BadgeVariant.PRIMARY]: css`
      background-color: ${theme.colors.grey_6};
      border: 1px solid ${theme.colors.grey_9};
    `,
    [BadgeVariant.SECONDARY]: css`
      background-color: ${theme.colors.purple_10};
      border: 1px solid ${theme.colors.purple_9};
    `,
  })[variant];

export const StyledBadge = styled.span<{
  $colorVariant: BadgeVariant;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 6px;
  width: fit-content;
  box-sizing: border-box;
  ${({ theme, $colorVariant }) => variantStyles(theme, $colorVariant)};
`;
